import { useState } from "react";
import { useSelector } from "react-redux";
import { Box, CircularProgress, Chip, ToggleButtonGroup, ToggleButton, Select, MenuItem, TextField, Button } from "@mui/material";
import {
  selectDetailStrategies,
  selectDetailLoading,
  selectDetailAnnualPerformance,
  selectAnnualPerformanceLoading,
  selectDetailPeriod,
  TIME_PERIODS,
} from "../../../../Redux/Reducers/strategyStoreSlice";
import AnnualPerformanceTable from "../../components/AnnualPerfomanceTable";
import AnnualPerformanceTableSkeleton from "../../components/AnnualPerformanceTableSkeleton";
import Chart from "./Chart";

const ChartSection = ({
  showPercentage,
  onTogglePercentage,
  investmentAmount,
  isSimulationActive,
  onPeriodChange,
  onCustomFetch,
}) => {
  const strategies = useSelector(selectDetailStrategies);
  const strategiesLoading = useSelector(selectDetailLoading);
  const annualPerformanceLoading = useSelector(selectAnnualPerformanceLoading);
  const period = useSelector(selectDetailPeriod);
  const annualPerformanceData = useSelector(selectDetailAnnualPerformance);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const parsedAmount = parseFloat(investmentAmount);

  const handleApplyCustom = () => {
    if (startDate && endDate) {
      onCustomFetch(startDate, endDate);
    }
  };

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} mb={2}>
        <Chip
          label={isSimulationActive ? "Simulated Return (USD)" : showPercentage ? "Return (%)" : "NAV"}
          size="small"
          variant="outlined"
        />
        <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
          <ToggleButtonGroup
            value={showPercentage ? "%" : "NAV"}
            exclusive
            size="small"
            onChange={(e, newValue) => {
              if (newValue !== null) onTogglePercentage(newValue === "%");
            }}
          >
            <ToggleButton value="NAV">NAV</ToggleButton>
            <ToggleButton value="%">&nbsp; % &nbsp;</ToggleButton>
          </ToggleButtonGroup>
          <Select
            value={period}
            onChange={onPeriodChange}
            size="small"
            sx={{ minWidth: 120 }}
          >
            {TIME_PERIODS.map((period) => (
              <MenuItem key={period.key} value={period.key}>
                {period.label}
              </MenuItem>
            ))}
          </Select>
          <TextField
            label="Start Date"
            type="date"
            size="small"
            value={startDate}
            disabled={period !== "custom"}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="End Date"
            type="date"
            size="small"
            value={endDate}
            disabled={period !== "custom"}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: startDate || undefined }}
          />
          <Button
            variant="contained"
            size="small"
            disabled={period !== "custom" || !startDate || !endDate || strategiesLoading}
            onClick={handleApplyCustom}
          >
            Apply
          </Button>
        </Box>
      </Box>

      <Box sx={{ position: "relative" }}>
        {strategiesLoading && (
          <Box sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
            <CircularProgress />
          </Box>
        )}
        <Chart
          strategies={strategies}
          investmentAmount={isSimulationActive ? parsedAmount : null}
          showPercentage={showPercentage}
          period={period}
        />
      </Box>

      {annualPerformanceLoading
        ? <AnnualPerformanceTableSkeleton />
        : annualPerformanceData && <AnnualPerformanceTable data={annualPerformanceData} />
      }
    </>
  );
};

export default ChartSection;
